export const environment = {
  production: false,
  label : "DEV",
  domain: "https://dev.idealcareerpath.com/auth",
  enableEmailAuth: false,
  firebaseConfig : {
    apiKey: "AIzaSyBBCMGssRr70VVFk_Q2BgAZBjEmtADz-Gk",
    authDomain: "ideal-career-path-dev.firebaseapp.com",
    databaseURL: "https://ideal-career-path-dev-default-rtdb.firebaseio.com",
    projectId: "ideal-career-path-dev",
    storageBucket: "ideal-career-path-dev.appspot.com",
    messagingSenderId: "644705328743",
    appId: "1:644705328743:web:5968c90b4eccb71ca73ec2",
    measurementId: "G-TS3LD2VN45"
  },
  moosendConfig: {
    domain: "api.moosend.com",
    apiKey:"bad8b08d-a527-4591-b847-9b240a98e691",
    mailingListID : "10a0ea9d-421c-4c48-8aad-94aed4118703",
    format: "json",
    version: "v3",
    paths: {
      subscribers: "subscribers",
      subscribe: "subscribe"
    }
  },
  captchaConfig: {
    path: {
      domain: "www.google.com",
      api: "https://www.google.com/recaptcha/api/siteverify",
      jsScript: "https://www.google.com/recaptcha/api.js" 
    },
    publicKey: "6Le4r9EcAAAAAEyg8XzFZkNDliwUl3sxojcdv6b4",
    secretKey: "6Le4r9EcAAAAAE8rQUhCepx6pYAkwDm24kJTErZO",
    options: {
      invisible: {
        sitekey: "6Le4r9EcAAAAAEyg8XzFZkNDliwUl3sxojcdv6b4"
      },
      normal: {
        sitekey: "6Le4r9EcAAAAAEyg8XzFZkNDliwUl3sxojcdv6b4"
      },
      language: "en"
    }
  },
  metaConfigs: {
    default: {
      "description": "Undecided About Your Career? Finding your perfect fit is a few clicks away.",
      "keywords": "career,path,ideal,students,education,skills,certificate,upskill,college",
      "author": "IdealCareerPath, LLC",
    }, 
    openGraph: {
      "og:title": "Find Your Perfect Career Fit.",
      "og:type": "website",
      "og:url": "https://dev.idealcareerpath.com",
      "og:image": "https://dev.idealcareerpath.com/assets/splash/success.png",
      "og:description": "Undecided About Your Career? Finding your perfect fit is a few clicks away.",
      "og:site_name": "IdealCareerPath",
      "og:image:width": "550",
      "og:image:height": "400",
    },
    twitter: {
      "twitter:title": "Find Your Perfect Career Fit.",
      "twitter:description": "Undecided About Your Career? Finding your perfect fit is a few clicks away.",
      "twitter:card": "summary_large_image",
      "twitter:image": "https://dev.idealcareerpath.com/assets/splash/success.png",
      "twitter:site": "@idealcareerpath",
      "twitter:creator": "@DAlexForce"    
    }
  },
  dynamicScript: {
    square: "square-sandbox",
    stripe: "stripe-sandbox"
  },
  p: {
    appId: "sandbox-sq0idb-tJWhtv9nQik8qJ47xD2gzQ",
    locationId: "LKT5RG0QQN7MS",
    publishKey:"pk_test_51LTGLsJjuMFVG1HAWd4F48vvn8IlenqWtU1EDKEq9kfKXvrzKVCSQ2ENcTqGw6vYcnOOm65UgzVp5vCTCa9Ou2aa00xEkezo1Z",
    clientSecret: ""
  },
  fbServer: { 
    basePath: 'https://us-central1-ideal-career-path-dev.cloudfunctions.net/',
    plink: 'createPaymentLink'
  }
};
